module.exports = __webpack_public_path__ + "img/umbrella-02.a7a306fb.svg";